import { useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { UserQueryKeys } from '../config/queryKeys';
import { getRequestHeaders } from '../lib/headers';
import { LegacyCoopClient } from '../lib/LegacyCoopClient';
import { type OktaUser, OktaUserSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export interface OktaUserQueryVariables {
  email: string;
}

export function useOktaUser<TData = OktaUser>(
  email: OktaUserQueryVariables['email'],
  options?: PresetUseQueryOptions<OktaUser, TData>,
) {
  const session = useWmgSession();

  const { data: oktaUser, ...query } = useQuery({
    queryKey: UserQueryKeys.oktaUser({ email }),
    queryFn: async () => {
      const data = await LegacyCoopClient.get('users/okta-user', {
        headers: getRequestHeaders(session.token),
        searchParams: { email },
      }).json();

      return OktaUserSchema.parse(data);
    },
    enabled: Boolean(email),
    ...options,
  });

  return { oktaUser, ...query };
}
